import(/* webpackMode: "eager" */ "/vercel/path0/app/(feed)/popular/page.tsx");
